<template>
  <div class="asc-export--container">
    <div class="asc-export-options">
      <v-radio-group
        ref="exportGroup"
        v-model="selectedOption"
        row
        :rules="[v => !!v]"
        @change="handleChange"
      >
        <div
          v-for="(item, index) in items"
          :key="index"
          class="asc-export-option"
        >
          <v-radio
            :label="item.title"
            :value="item"
            class="asc-export-option--radio"
            :ripple="false"
          ></v-radio>
          <asc-date-picker
            v-if="selectedOption === item"
            v-model="dateSelectorOptions"
            label="Select Date"
            :max-days="maxDays"
            :has-icon="true"
            :drop-down="true"
            :show-fixed-options="true"
            :hide-options-with-id="[1]"
            auto-re-position
            hide-details
            class="asc-export-option--date-selector"
            @input="handleInput()"
          ></asc-date-picker>
        </div>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import AscDatePicker from '@/components/atoms/AscDatePicker'
import { getDateGivenOffset } from '@/utilities/dates'

export default {
  name: 'AscExportMxRec',

  components: {
    AscDatePicker,
  },

  props: {
    value: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      selectedOption: null,
      maxDays: 45,
      maxDate: new Date(),
      dateSelectorOptions: {
        dates: {
          startDate: getDateGivenOffset(new Date(), -30),
          endDate: new Date(),
          value: '4',
        },
      },
    }
  },

  mounted() {
    this.handleInput()
  },

  methods: {
    handleChange() {
      // Reset the date picker
      this.dateSelectorOptions = {
        dates: {
          startDate: getDateGivenOffset(new Date(), -30),
          endDate: new Date(),
          value: '4',
        },
      }
    },
    handleInput() {
      const data = { ...this.selectedOption, ...this.dateSelectorOptions }
      this.$emit('input', data)
    },
  },
}
</script>

<style lang="scss">
.asc-export--container {
  .asc-export-options {
    margin-left: 27px;
    margin-top: 5px;

    .asc-export-option {
      margin-bottom: 30px;

      &--radio {
        & > div > .v-icon {
          font-size: 20px;
        }

        & > label {
          color: $primary-black;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 18px;
        }
      }

      &--date-selector {
        max-width: 256px;
        margin-left: 32px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
